import React from 'react';
import PageContainer from "../../../../hoc/PageContainer";

const MakeASmile = () => (
    <div>
        <PageContainer page="makeASmile">
            <h2 className="AboutUsTitle" id="make-a-smile-h1">Rotary Club of Central - Year 2015-2016: Make A SMILE</h2>
            <div className="our-services-video-container">
                <iframe src="https://player.vimeo.com/video/189416839" width="854" height="480" frameBorder="0"
                        allow="autoplay; fullscreen" allowFullScreen/>
            </div>
            <div className="AboutUsText">
                RCC partnered with the Hong Kong Down Syndrome Association to offer support to one of the most disadvantaged groups in the society. This project aimed to promote a sense of awareness, communion and inclusion towards Down syndrome children / youths; provide fraternal and mentoring support to this target group via a series of educational, team building, physical and communal activities; To engage family members of Down syndrome children / youths on a series of community / stress relieving activities to improve on mental / physical fitness.
            </div>

        </PageContainer>
    </div>
);

export default MakeASmile;
